module.exports = __webpack_public_path__ + "img/mi-brush.9a6fbf4d.svg";